
<div *ngIf="productInitializing" class="text-center" style="width:100%;height:100%; border:1px solid black;">
  <kendo-loader *ngIf="imageLoading" style="color:blue;font-size:64px;left:0;top:200px;right:0;bottom:0;"></kendo-loader>
</div>
<!-- Vertical splitter -->
<kendo-splitter orientation="vertical" *ngIf="!productInitializing">
  <kendo-splitter-pane title="Please review each door" size="230px" min="5%">
    <div *ngIf="1===1" class="row">
      <div class="col-md-6">
        <span>
          <b>Configuration:</b>&nbsp;{{pt.computedName}}
        </span><br />
        <span>
          <b>Description:</b>&nbsp;{{pt.productName}}
        </span><br />
        <span>
          <b>Unit Price:</b>&nbsp;{{pt.unitNetSellPrice}}
        </span><br />
        <span>
          <b>Gross Price:</b>&nbsp;{{pt.unitGrossSellPrice}}
        </span><br />
        <!--<span>
          <b>Time taken for api call:</b>&nbsp;{{apiDuration}}
        </span>-->
      </div>
      <div class="col-md-6">
        <div class="text-center" style="line-height:210px;height:210px;">
          <kendo-loader *ngIf="imageLoading" style="color:blue"></kendo-loader>
          <img id="myimage" [src]='thumbnail' *ngIf="thumbnail" width="200">
        </div>
      </div>
    </div>

  </kendo-splitter-pane>
  <kendo-splitter-pane title="Bottom pane" style="min-height: 500px;height:100%">
    <div class="screen-container" *ngIf="currentProductConfigStep===0">
      <app-bp1 (outputResponse)="responseReceiveBP1($event)"></app-bp1>
    </div>
    <div class="screen-container" *ngIf="currentProductConfigStep===1">
      <app-bp2 (outputResponse)="responseReceiveBP2($event)"></app-bp2>
    </div>
    <div class="screen-container" *ngIf="currentProductConfigStep===2">
      <app-bp3></app-bp3>
    </div>
  </kendo-splitter-pane>
</kendo-splitter>

<section>
  <ng-template #kInformationTemplate let-kInformationTemplateAnchor>
    <div lass="text-white-50 bg-dark">
      <ol>
        <li>An item</li>
        <li>A second item</li>
        <li>A third item</li>
        <li>A fourth item</li>
        <li>And a fifth one</li>
      </ol>
    </div>
  </ng-template>
</section>


